/**
 * @generated SignedSource<<c32b41c45e8b799b2973a70447a4459c>>
 * @relayHash a23c8763d9fb621e19f9d83ffa0b66af
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a23c8763d9fb621e19f9d83ffa0b66af

import { ConcreteRequest } from 'relay-runtime';
export type De_updateProgressNoteTreatmentPlanInput = {
  followUpInstructions?: string | null;
  from: any;
  id: string;
  recommended?: string | null;
  title: string;
  to: any;
};
export type deUpdateProgressNoteTreatmentPlanMutation$variables = {
  input: De_updateProgressNoteTreatmentPlanInput;
};
export type deUpdateProgressNoteTreatmentPlanMutation$data = {
  readonly updateProgressNoteTreatmentPlan: {
    readonly ProgressNoteMutationOutput: {
      readonly episodeOfCare: {
        readonly id: string;
        readonly patientId: string;
        readonly updatedAt: string;
      } | null;
      readonly progressNote: {
        readonly id: string;
        readonly treatmentPlan: {
          readonly followUpInstructions: string | null;
          readonly from: any;
          readonly recommended: string | null;
          readonly title: string;
          readonly to: any;
        } | null;
        readonly updatedAt: string;
      };
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type deUpdateProgressNoteTreatmentPlanMutation = {
  response: deUpdateProgressNoteTreatmentPlanMutation$data;
  variables: deUpdateProgressNoteTreatmentPlanMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v4 = {
  "alias": "ProgressNoteMutationOutput",
  "args": null,
  "concreteType": "de_ProgressNoteMutationOutput",
  "kind": "LinkedField",
  "name": "de_ProgressNoteMutationOutput",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "de_EpisodeOfCare",
      "kind": "LinkedField",
      "name": "episodeOfCare",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "patientId",
          "storageKey": null
        },
        (v3/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "de_ProgressNote",
      "kind": "LinkedField",
      "name": "progressNote",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        (v3/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TreatmentPlan",
          "kind": "LinkedField",
          "name": "treatmentPlan",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "from",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "to",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "followUpInstructions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "recommended",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deUpdateProgressNoteTreatmentPlanMutation",
    "selections": [
      {
        "alias": "updateProgressNoteTreatmentPlan",
        "args": (v1/*:: as any*/),
        "concreteType": "De_updateProgressNoteTreatmentPlanPayload",
        "kind": "LinkedField",
        "name": "de_updateProgressNoteTreatmentPlan",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deUpdateProgressNoteTreatmentPlanMutation",
    "selections": [
      {
        "alias": "updateProgressNoteTreatmentPlan",
        "args": (v1/*:: as any*/),
        "concreteType": "De_updateProgressNoteTreatmentPlanPayload",
        "kind": "LinkedField",
        "name": "de_updateProgressNoteTreatmentPlan",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "a23c8763d9fb621e19f9d83ffa0b66af",
    "metadata": {},
    "name": "deUpdateProgressNoteTreatmentPlanMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b270e805a05c07e87fb3e700d9c1cf57";

export default node;
